import React, { useEffect, useContext } from 'react'
import marked from 'marked'
import axios from 'axios'
import { URL, PARTNERS_PAGE_API } from '../../config'
import { AppContext } from '../App'

const Credits = ({ closeAction }) => {
  const { credits, setCredits, lang, getTranslatedUiLabel } = useContext(AppContext)

  useEffect(() => {
    if (!credits) {
      axios.get(URL + PARTNERS_PAGE_API)
        .then(({data}) => setCredits(data))
    }
  }, [])

  return <div className="App-credits">
      <p onClick={closeAction} className="App-back-button">&larr; {getTranslatedUiLabel(18)}</p>
      <div className="App-credits-container" dangerouslySetInnerHTML={{__html: credits && marked(credits[lang])}}></div>
      <div>
        {credits && credits.imageLinks.map(iml => <a href={iml.URL || '#'}><img className="App-image-link" src={URL + iml.Image.url} /></a>)}
      </div>
  </div>
}

export default Credits